import { useCallback } from 'react';

import { calculateAdjustedPrices, ICalculateAdjustedPricesResult } from 'shared/utils/priceCorrection';

const DEFAULT_PRICES_MIN_GAP = 1000;

export interface IUsePriceCorrectionParams {
  pricesMinGap?: number;
}

export interface ICalculateCorrectionParams {
  newMin: number | null;
  newMax: number | null;
  isMinChanged: boolean;
}

export interface ICalculateCorrectionResult {
  adjustedMin: number | null;
  adjustedMax: number | null;
  wasCorrected: boolean;
}

/**
 * Хук для расчёта скорректированных цен с учётом минимального разбега.
 *
 * @param pricesMinGap - минимальный разбег между ценами (по умолчанию 1000)
 * @returns функция расчёта скорректированных цен
 */
export function usePriceCorrection({ pricesMinGap = DEFAULT_PRICES_MIN_GAP }: IUsePriceCorrectionParams = {}): (
  params: ICalculateCorrectionParams,
) => ICalculateCorrectionResult {
  return useCallback(
    ({ newMin, newMax, isMinChanged }: ICalculateCorrectionParams): ICalculateCorrectionResult => {
      const result: ICalculateAdjustedPricesResult = calculateAdjustedPrices({
        min: newMin,
        max: newMax,
        isMinChanged,
        pricesMinGap,
      });

      return {
        adjustedMin: result.adjustedMin,
        adjustedMax: result.adjustedMax,
        wasCorrected: result.needsAdjustment,
      };
    },
    [pricesMinGap],
  );
}
